<template>
  <div :class="globalStore.getIsGreyLabel ? 'sidebar-inner grey-label' : ''">
    <OrderAccordion v-show="showAccordion" />
    <ProgressBar />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { whenever } from "@vueuse/core";

import useApiHelpers from "@/composables/api/helpers";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";
import { useGlobalStore } from "@/stores/globalStore";
import ProgressBar from "@/components/layout/ProgressBarWrapper.vue";
import OrderAccordion from "@/components/layout/OrderAccordion.vue";

const route = useRoute();
const store = useOrderFormStore();
const globalStore = useGlobalStore();
const { getRequest } = useApiHelpers();
const hideAccordionBasedOnRoutes = [
  "order",
  "verification",
  "verificationCode",
  "summary",
  "order.papi"
];

const showAccordion = computed(
  () => route.name && !hideAccordionBasedOnRoutes.includes(route.name)
);
whenever(showAccordion, async () => {
  const data = await getRequest("/summary");
  if (data) {
    Object.entries(data.data.data).forEach(([key, value]) => {
      if (value) store.updateOrderAccordion(key, value);
    });
  }
});
</script>

<style lang="scss">
.sidebar-inner.grey-label {
  display: flex;
  flex-direction: column;
  width: 100%;

  @include breakpoint($min-m) {
    margin-top: 0;
    padding-top: 4em;
    justify-content: flex-end;
  }

  > div.order-accordion {
    max-width: 50rem;
  }
}
</style>
